import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import BrandLogo from '../../icons/logo.svg';
import { noop } from '../propTypes';

function WelcomeComponent({
    mainHeading,
    pointHeading,
    points,
    descriptionHeading,
    description,
    onClick,
    buttonText,
}) {
    return (
        <div className="welcomeCard">
            <div className="card customCard mx-auto p-4 cardShadow">
                <img src={BrandLogo} className="litteratiLogo" alt="logo" />
                {mainHeading && mainHeading.length ? (
                    <h2 className="heading bold">{mainHeading}</h2>
                ) : null}

                <div className="card-body p-0">
                    {pointHeading && pointHeading.length ? (
                        <p>{pointHeading}</p>
                    ) : null}
                    {points && points.length ? (
                        <ol className="getStartedPoints">
                            {points.map((singlepoint) => {
                                return (
                                    <li key={`key_${singlepoint}`}>
                                        {singlepoint}
                                    </li>
                                );
                            })}
                        </ol>
                    ) : null}

                    {descriptionHeading && descriptionHeading.length ? (
                        <div className="descriptionHeading">
                            {descriptionHeading}
                        </div>
                    ) : null}
                    {description}
                </div>
                {buttonText && buttonText.length ? (
                    <button
                        onClick={onClick}
                        className="btn btn-primary btn-block btn-getstarted"
                    >
                        {buttonText}
                    </button>
                ) : null}
            </div>
        </div>
    );
}

WelcomeComponent.propTypes = {
    mainHeading: PropTypes.string,
    pointHeading: PropTypes.string,
    points: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    descriptionHeading: PropTypes.string,
    description: PropTypes.node,
    onClick: PropTypes.func,
    buttonText: PropTypes.string,
};

WelcomeComponent.defaultProps = {
    mainHeading: null,
    pointHeading: null,
    points: null,
    descriptionHeading: null,
    description: null,
    onClick: noop,
    buttonText: null,
};

export default WelcomeComponent;
